<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Customers</h1>

<div>
  <!-- Loading -->
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

  <!-- Customers -->
  <div class="ag-grid-container">
    <ag-grid-angular #agGrid class="ag-theme-alpine ag-grid" [gridOptions]="gridOptions">
    </ag-grid-angular>
  </div>
  <!-- Create Account Action -->
  <div class="button-div">
    <button class="button-action" mat-raised-button color="primary" (click)="openCreateAccount()"
      [disabled]="canCreateAccount()">
      <mat-icon>open_in_new</mat-icon>
      Create Account
    </button>
  </div>
  <!-- Fleet Users -->
  <div *ngIf="selectedCustomer" class="button-div">
    <button class="button-action" mat-raised-button color="primary" [routerLink]="['/erm/fleet-users', selectedCustomer.customerId]">
      <mat-icon>open_in_new</mat-icon>
      Fleet Users
    </button>
  </div>

  <!-- Selected customer -->
  <div *ngIf="selectedCustomer">
    <p>
      <strong>Customer Id: </strong>
      <a [routerLink]="['/erm/customers', selectedCustomer.customerId]">{{selectedCustomer.customerId}}</a>
    </p>
    <pre>{{selectedCustomer | json}}</pre>
  </div>
</div>